<div class="main-container">
  <div class="header">
    <div class="warnig-with-icon ">
      <img src="\assets\icons\warning.png" />
      <label class="warning mt-2">Reported</label>
    </div>
    <div class="close-icon mt-2">
      <img src="\assets\icons\close.png" (click)="onCancel()" />
    </div>
  </div>
  <div class="line"></div>

  <div class="body-text">
    <label> The {{selectedIssue}} has been reported!</label>
    <!-- Add more cases if needed -->
  </div>

  <div class="footer">
    <button class="yes" (click)="onConfirm()">Okay</button>
  </div>
</div>
